export default __webpack_public_path__ + "static/media/hoyoung.cc015654.png";